var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeading = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 43,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 93.288,
  height: 4,
  x: 26.712,
  y: 6.415,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-text)",
  d: "m14.837 2.45.288.383-2.784 2.672V3.154L15.189.385h1.488v11.2h-1.84zM1.36.385h1.936v4.737h5.2V.385h1.936v11.2H8.496V6.85h-5.2v4.736H1.36z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 4,
  y: 22.415,
  fill: "var(--hop-neutral-surface-weak)",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 4,
  y: 38.415,
  fill: "var(--hop-neutral-surface-weak)",
  rx: 2
})));
export default SvgHeading;